<template>
  <button
    class="dice-launcher"
    :class="{ active }"
    type="button"
    :aria-label="$t(active ? 'Close' : 'Open Tài Xỉu tables')"
    :aria-expanded="String(active)"
    @click="$emit('click')"
  >
    <span class="dice-button" aria-hidden="true">
      <img
        class="dice-icon"
        :src="active ? require('@/assets/images/dice-icon-active.svg') : require('@/assets/images/dice-icon-default.svg')"
        alt=""
      />
    </span>
  </button>
</template>

<script>
export default {
  props: {
    active: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.dice-launcher {
  height: 34px;
  box-sizing: border-box;
  /* A button's UA padding is 1px 6px -- without this the dice sits 6px right
     of wherever it is placed, which is what shifted it against the table bar. */
  padding: 0;
  border: 0;
  background-color: transparent;
  display: grid;
  place-items: center;
  cursor: pointer;
  transition: transform 0.2s ease;
  outline: none;
  -webkit-tap-highlight-color: transparent;

  &:hover,
  &:focus,
  &:focus-visible,
  &:active {
    outline: none;
    border: 0;
    box-shadow: none;
    background-color: transparent;
  }

  &::-moz-focus-inner {
    border: 0;
  }
}

.dice-button {
  width: 22px;
  height: 22px;
  box-sizing: border-box;
  display: grid;
  place-items: center;
}

/*
 * Both icons are 32x32 with the dice drawn at the same 25.42 x 28.66 and
 * centred, so one size serves the default and the active state.
 */
.dice-icon {
  width: 20px;
  height: 20px;
}
</style>
